module.exports = __webpack_public_path__ + "static/media/no-review-image.bab45062.svg";